import React, { Component } from "react";
import BarcodeScanner from "react-qr-barcode-scanner";
import { Button, Modal, Transition, Image } from "semantic-ui-react";
import ProductListItem from "components/Product/ProductListItem"

class BarcodeScannerJS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: "Not Found",
            barcodeModal: false,
        };
    }

    handleUpdate = async (err, result) => {
        
        if (result) {
            this.setState({ data: result.text });
            //console.log("Barcode data found", result.text);
            // Call the setBarcodeData function passed from the parent component
            if (!this.scanTimeout) {
                if (this.props.setBarcodeData) {
                    await this.props.setBarcodeData(result.text);
                    console.log("Barcode data set in parent component", result.text);

                
                    const audio = new Audio('/barcodeScan.mp3'); // Replace with the actual path to your audio file
                    audio.volume = 0.1; // Set the volume to 20%
                    audio.play();
                    this.scanTimeout = setTimeout(() => {
                    this.scanTimeout = null; // Reset the timeout after 1.5 seconds
                    }, 2500);
                }
            }
        } else {
            this.setState({ data: "Not Found" });
            //console.log("No barcode detected");
        }
    };



    render() {
        const { barcodeModal } = this.state;
        //console.log("this.props", this.props);
        return (
            <div>
                <Button primary onClick={() => this.setState({ barcodeModal: true })}>Barcode Scanner</Button>
                <Modal
					open={barcodeModal}
                    onClose={() => this.setState({ barcodeModal: false })}
					closeIcon={<Button floated={"right"} basic icon={"close"} />}>
					<Modal.Content className=" tc center">   
                    <div className="pt3 pb3 tc"><BarcodeScanner
                    width={300}
                    height={300}
                    onUpdate={(err, result) => {
                        //console.log("onUpdate called", { err, result });
                        this.handleUpdate(err, result);
                    }}
                />
                {/*<p>{this.state.data}</p>*/}
                {this.props && this.props.productSearch && this.props.productSearch.length == 0 && this.state.data != "Not Found" && <p className="pa3">Keinen Artikel zum gescannten Barcode gefunden.</p>}
                { this.props && this.props.productSearch && this.props.productSearch.length > 0 && this.props.productSearch.length < 2 &&
                    this.props.productSearch.map( ( product, index ) =>    
                    <ProductListItem    flashing={true}
                                        index={index}
                                        key={product.map_id}
                                        product={product}
                                        /> )}
                                        </div>

					</Modal.Content>
				</Modal>

            </div>
        );
    }
}

export default BarcodeScannerJS;


// WEBPACK FOOTER //
// ./src/components/BarcodeScanner/BarcodeScannerJS.js